// src/api/axiosInstance.js
import axios from 'axios';
import { baseUrl } from '../config/default';

const axiosInstance = axios.create({
    baseURL: baseUrl, // example base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('suat');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

// Add response interceptor
axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.error('[Error]', error.response);
        return Promise.reject(error);
    }
);

export default axiosInstance;
